import React, { Component } from 'react'
import Loader from '../UI/Loader'
import { LocationMarkerIcon, CalendarIcon, TrashIcon, XIcon } from '@heroicons/react/solid'

class Bookings extends Component {
	constructor(props) {
		super(props)
		this.state = {
			form1: {
				lang: this.props.user.langage
			},
			error: null,
			cancelConfirm: null
		}
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Membres')
		this.props.updateShell('profile', true, this.props.history.location.pathname)
		this.props.fetchNotifications()
		this.loadReservations()
	}

	loadReservations = (fromProps = false) => {
		this.props.fetchServices()
		.then(services => {
			this.props.fetchServiceBenefits()
			.then(service_benefits => {
				this.props.fetchServiceReservationsByUser(this.props.user._id)
				.then(reservations => {
					for (let i = 0; i < reservations.length; i++)
					{
						for (let j = 0; j < service_benefits.length; j++)
						{
							const service_benefit = service_benefits[j]
							if (reservations[i].service_benefit === service_benefit._id)
							{
								reservations[i].service_benefit = service_benefit
								break
							}
						}
						if (!reservations[i].service_benefit || typeof reservations[i].service_benefit !== 'object')
						{
							const serviceId = reservations[i].service
							for (let j = 0; j < service_benefits.length; j++)
							{
								if (service_benefits[j].service === serviceId)
								{
									reservations[i].service_benefit = service_benefits[j]
									break
								}
							}
						}
						if (!reservations[i].service_benefit || typeof reservations[i].service_benefit !== 'object')
						{
							for (let j = 0; j < services.length; j++)
							{
								const service = services[j]
								if (reservations[i].service === service._id)
								{
									reservations[i].service = service
									break
								}
							}
						}
					}
					reservations = reservations.filter(r =>
						(typeof r.service_benefit === 'object' && r.service_benefit !== null) ||
						(typeof r.service === 'object' && r.service !== null)
					)
					reservations.sort((a, b) => a.start - b.start)
					this.setState({ reservations: reservations, services: services })
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		})
		.catch(err => console.log(err))
	}

	cancelReservation = (service_reservation) => {
		let found = -1
		const reservations = this.state.reservations
		for (let i = 0; i < reservations.length; i++)
		{
			if (reservations[i]._id === service_reservation)
			{
				found = i
				break
			}
		}
		if (found === -1) return
		const original = reservations[found]
		const newReservations = reservations.map((r, i) =>
			i === found ? { ...r, cancelled: true, cancelled_by: 'client' } : r
		)
		this.setState({ reservations: newReservations, cancelConfirm: null })
		this.props.postDeleteServiceReservation(service_reservation)
		.then(ret => {
			if (ret !== true)
			{
				this.setState(prev => ({
					reservations: prev.reservations.map((r, i) => i === found ? original : r)
				}))
			}
		})
		.catch(() => {
			this.setState(prev => ({
				reservations: prev.reservations.map((r, i) => i === found ? original : r)
			}))
		})
	}

	startCancelConfirm = (id) => {
		this.setState({ cancelConfirm: id })
	}

	abortCancelConfirm = () => {
		this.setState({ cancelConfirm: null })
	}

	render() {
		const reservations = this.state.reservations
		const themeColor = '#' + this.props.theme.color1
		const weekdays = this.props.lang_assets.time.weekdays
		const month_list = this.props.lang_assets.time.months

		if (!reservations)
		{
			return (
				<div>
					<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
						<h1 className="text-3xl text-white font-semibold m-0 pt-16">Mes réservations</h1>
					</div>
					<div className="rounded-t-3xl z-10" style={{ backgroundColor: '#ffffff', marginTop: '-2rem' }}>
						<div className="px-4 pt-8 pb-28">
							<div className="loading" style={{ marginTop: '30vh' }}>
								<Loader />
							</div>
						</div>
					</div>
				</div>
			)
		}

		const now = Date.now()
		const upcoming = reservations.filter(r => r.start * 1000 > now)
		const past = reservations.filter(r => r.start * 1000 <= now).reverse()
		const cancelConfirm = this.state.cancelConfirm

		// Données de la réservation à annuler (pour le bottom sheet)
		const confirmRes = cancelConfirm ? reservations.find(r => r._id === cancelConfirm) : null
		let confirmSubtitle = ''
		let confirmDateStr = ''
		if (confirmRes)
		{
			const isBenefit = confirmRes.service_benefit !== null
			const translations = isBenefit ? confirmRes.service_benefit.translations : confirmRes.service.translations
			if (translations)
			{
				for (let i = 0; i < translations.length; i++)
				{
					if (translations[i].lang === this.props.user.langage)
					{
						confirmSubtitle = translations[i].subtitle
						break
					}
				}
			}
			const d = new Date(confirmRes.start * 1000)
			let day = d.getDate()
			if (day < 10) day = '0' + day
			let hour = d.getHours()
			if (hour < 10) hour = '0' + hour
			let minute = d.getMinutes()
			if (minute < 10) minute = '0' + minute
			confirmDateStr = weekdays[d.getDay()] + ' ' + day + ' ' + month_list[d.getMonth()] + ' · ' + hour + 'h' + minute
		}

		const services = this.state.services || []
		const renderCard = ({ _id, service, service_benefit, start, end, self, participants, cart, cancelled, cancelled_by }) => {
			const serviceId = typeof service === 'object' ? service._id : service
			const serviceObj = services.find(s => s._id === serviceId)
			const cancelLimit = typeof service_benefit === 'object' && service_benefit && service_benefit.cancel_limit != null
				? Number(service_benefit.cancel_limit)
				: (serviceObj && serviceObj.cancel_limit != null ? Number(serviceObj.cancel_limit) : 0)
			const canCancel = cancelLimit === 0 || (now + cancelLimit * 3600 * 1000 <= start * 1000)
			const date = new Date(start * 1000)
			const weekday = weekdays[date.getDay()]
			let day = date.getDate()
			if (day < 10) day = '0' + day
			const month = month_list[date.getMonth()]
			const year = date.getFullYear()
			let hour = date.getHours()
			if (hour < 10) hour = '0' + hour
			let minute = date.getMinutes()
			if (minute < 10) minute = '0' + minute

			let endHour = null
			let endMinute = null
			if (end)
			{
				const endDate = new Date(end * 1000)
				endHour = endDate.getHours()
				if (endHour < 10) endHour = '0' + endHour
				endMinute = endDate.getMinutes()
				if (endMinute < 10) endMinute = '0' + endMinute
			}

			const isBenefit = typeof service_benefit === 'object' && service_benefit !== null
			const translations = isBenefit ? service_benefit.translations : (typeof service === 'object' && service ? service.translations : null)
			let subtitle = ''
			let location = ''
			if (translations)
			{
				for (let i = 0; i < translations.length; i++)
				{
					if (translations[i].lang === this.props.user.langage)
					{
						subtitle = translations[i].subtitle
						location = translations[i].location
						break
					}
				}
			}
			// Pour vente : utiliser le nom du service comme titre
			if (!isBenefit && !subtitle && serviceObj && serviceObj.name)
				subtitle = serviceObj.name

			const isUpcoming = start * 1000 > now

			// Avatars participants
			let participantsJSX = null
			if (isBenefit)
			{
				const avatars = []
				if (self === true)
				{
					const fi = (this.props.user.firstname || '')[0] || ''
					const li = (this.props.user.lastname || '')[0] || ''
					avatars.push((fi + li).toUpperCase())
				}
				if (participants)
				{
					for (let i = 0; i < participants.length; i++)
					{
						const fi = (participants[i].firstname || '')[0] || ''
						const li = (participants[i].lastname || '')[0] || ''
						avatars.push((fi + li).toUpperCase())
					}
				}
				if (avatars.length > 0)
				{
					participantsJSX = (
						<div className="flex items-center gap-1 mt-3">
							{avatars.map((initials, i) => (
								<div key={i} className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{ backgroundColor: cancelled ? '#9ca3af' : themeColor }}>
									{initials}
								</div>
							))}
						</div>
					)
				}
			}

			// Résumé panier
			let cartJSX = null
			if (!isBenefit && cart && cart.length > 0)
			{
				let total = 0
				const items = cart.map(({ _id, translations: tr, price, quantity }) => {
					let name = ''
					if (tr)
					{
						for (let i = 0; i < tr.length; i++)
						{
							if (tr[i].lang === this.props.user.langage)
							{
								name = tr[i].title || tr[i].subtitle || ''
								break
							}
						}
						if (!name && tr.length > 0)
							name = tr[0].title || tr[0].subtitle || ''
					}
					const qty = Number(quantity)
					const p = Number(price)
					total += p * qty
					return { _id, name, qty, price: p }
				})
				cartJSX = (
					<div className="mt-3 space-y-1">
						{items.map(({ _id, name, qty, price: p }) => (
							<div key={_id} className="flex items-center justify-between gap-4">
								<span className="text-sm text-gray-500 flex-1 min-w-0 truncate">{qty}× {name}</span>
								{p > 0 && <span className="text-sm font-medium text-gray-700 flex-shrink-0 tabular-nums text-right w-16">{(p * qty).toFixed(2).replace('.', ',')}€</span>}
							</div>
						))}
						<div className="flex items-center justify-between pt-1.5 border-t border-gray-100 mt-1.5">
							<span className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Total</span>
							<span className="text-sm font-bold text-gray-800 tabular-nums text-right w-16">{total.toFixed(2).replace('.', ',')}€</span>
						</div>
					</div>
				)
			}

			return (
				<div key={_id} className={`rounded-2xl overflow-hidden shadow-sm border ${cancelled ? 'border-gray-200 opacity-60' : 'border-gray-100'}`}>
					<div className="px-4 py-3" style={{ backgroundColor: cancelled ? '#f3f4f6' : themeColor + '18' }}>
						<div className="flex items-start justify-between gap-2">
							<h3 className={`text-base font-bold leading-tight ${cancelled ? 'line-through text-gray-400' : ''}`} style={cancelled ? {} : { color: themeColor }}>{subtitle}</h3>
							{cancelled
								? <span className="text-xs font-semibold px-2 py-0.5 rounded-full flex-shrink-0 text-white" style={{ backgroundColor: '#9ca3af' }}>{cancelled_by === 'staff' ? 'Annulée par l\'établissement' : 'Annulée'}</span>
								: <span className="text-xs font-semibold px-2 py-0.5 rounded-full flex-shrink-0 text-white" style={{ backgroundColor: isUpcoming ? themeColor : '#9ca3af' }}>{isUpcoming ? 'À venir' : 'Passée'}</span>
							}
						</div>
						{location ? (
							<div className="flex items-center mt-1">
								<LocationMarkerIcon className="w-3 h-3 mr-1 flex-shrink-0" style={{ color: cancelled ? '#9ca3af' : themeColor, opacity: 0.6 }} />
								<span className="text-xs" style={{ color: cancelled ? '#9ca3af' : themeColor, opacity: 0.7 }}>{location}</span>
							</div>
						) : null}
					</div>
					<div className="border-t border-dashed border-gray-200" />
					<div className={`px-4 py-3 ${cancelled ? 'bg-gray-50' : 'bg-white'}`}>
						<div className="flex items-start justify-between">
							<div>
								<p className="text-sm font-medium text-gray-500 capitalize">{weekday} {day} {month} {year}</p>
								<p className="text-xl font-bold text-gray-800 mt-0.5">
									{hour}h{minute}
									{endHour ? <span className="text-gray-400 text-base font-normal"> → {endHour}h{endMinute}</span> : null}
								</p>
								{participantsJSX}
							</div>
							{isUpcoming && !cancelled && (
								<div className="flex flex-col items-end gap-1">
									<button
										type="button"
										onClick={canCancel ? () => this.startCancelConfirm(_id) : undefined}
										className={`p-1.5 rounded-full ${canCancel ? 'text-gray-800' : 'text-gray-300 cursor-not-allowed'}`}
										disabled={!canCancel}
									>
										<TrashIcon className="w-6 h-6" />
									</button>
									{!canCancel && <span className="text-xs text-gray-400">Annulation impossible</span>}
								</div>
							)}
						</div>
						{cartJSX}
					</div>
				</div>
			)
		}

		// Bottom sheet annulation
		const sheetOpen = cancelConfirm !== null
		const backdropStyle = {
			position: 'fixed',
			inset: 0,
			backgroundColor: 'rgba(0,0,0,0.45)',
			zIndex: 50,
			opacity: sheetOpen ? 1 : 0,
			pointerEvents: sheetOpen ? 'auto' : 'none',
			transition: 'opacity 0.25s ease'
		}
		const sheetStyle = {
			position: 'fixed',
			bottom: 0,
			left: 0,
			right: 0,
			zIndex: 51,
			backgroundColor: '#ffffff',
			borderRadius: '24px 24px 0 0',
			padding: '12px 24px 40px',
			transform: sheetOpen ? 'translateY(0)' : 'translateY(100%)',
			transition: 'transform 0.32s cubic-bezier(0.32, 0.72, 0, 1)'
		}

		return (
			<div>
				<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
					<h1 className="text-3xl text-white font-semibold m-0 pt-16">Mes réservations</h1>
				</div>
				<div className="rounded-t-3xl z-10" style={{ backgroundColor: '#ffffff', marginTop: '-2rem' }}>
					<div className="px-4 pt-8 pb-28">
						{reservations.length === 0 ? (
							<div className="flex flex-col items-center justify-center pt-16 text-center">
								<CalendarIcon className="w-12 h-12 text-gray-200" />
								<p className="mt-4 text-gray-400 text-base">Aucune réservation à venir</p>
							</div>
						) : (
							<div>
								{upcoming.length > 0 && (
									<div>
										<p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3 px-1">À venir</p>
										<div className="space-y-4">
											{upcoming.map(r => renderCard(r))}
										</div>
									</div>
								)}
								{past.length > 0 && (
									<div className={upcoming.length > 0 ? 'mt-8' : ''}>
										<p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3 px-1">Passées</p>
										<div className="space-y-4">
											{past.map(r => renderCard(r))}
										</div>
									</div>
								)}
							</div>
						)}
					</div>
				</div>

				{/* Backdrop */}
				<div style={backdropStyle} onClick={this.abortCancelConfirm} />

				{/* Bottom sheet */}
				<div style={sheetStyle}>
					<div className="flex justify-center mb-4">
						<div style={{ width: 36, height: 4, borderRadius: 2, backgroundColor: '#e5e7eb' }} />
					</div>
					<div className="flex items-center justify-between mb-6">
						<h2 className="text-xl font-bold text-gray-900">Annuler la réservation ?</h2>
						<button type="button" onClick={this.abortCancelConfirm} className="p-1 text-gray-400">
							<XIcon className="w-5 h-5" />
						</button>
					</div>
					{confirmRes && (
						<div className="rounded-2xl px-4 py-3 mb-6" style={{ backgroundColor: themeColor + '12' }}>
							<p className="font-semibold text-gray-800">{confirmSubtitle}</p>
							<p className="text-sm text-gray-500 mt-0.5 capitalize">{confirmDateStr}</p>
						</div>
					)}
					<button
						type="button"
						onClick={() => this.cancelReservation(cancelConfirm)}
						className="w-full py-4 rounded-full text-white font-semibold text-base bg-gray-900"
					>
						Confirmer l'annulation
					</button>
					<button
						type="button"
						onClick={this.abortCancelConfirm}
						className="w-full py-3 mt-2 text-gray-500 text-sm font-medium"
					>
						Non, garder ma réservation
					</button>
				</div>
			</div>
		)
	}
}

export default Bookings
